module.exports = __webpack_public_path__ + "img/loadtunay.21798084.gif";